import { onUnmounted, onMounted } from '@vue/composition-api';

export const useEventBusListener = (
  target: {
    eventBus: {
      $on: (event: string, callback: Function) => void;
      $off: (event: string, callback: Function) => void;
    };
  },
  event: string,
  handler: Function
) => {
  onMounted(() => {
    target.eventBus.$on(event, handler);
  });

  onUnmounted(() => {
    target.eventBus.$off(event, handler);
  });
};

export const useEventBusEmit = (
  target: {
    eventBus: {
      $emit: (event: string, ...args: any[]) => void;
    };
  },
  event: string,
  ...args: any[]
) => target.eventBus.$emit(event, ...args);